export interface BaseBuilder {
  userId?: string
  createdAt?: string
  updatedAt?: string
}

export interface SocialMedia extends BaseBuilder {
  value: string
  name: string
}

export interface Wallet extends BaseBuilder {
  wallet: string
  chainId?: number
}

export interface UserAvatar extends File {
  preview: string
}

export interface PersonalDetails extends BaseBuilder {
  email?: string
  username?: string
  bio?: string
  banner?: string
  avatar?: string
  firstName?: string
  lastName?: string
  country?: string
  birthDate?: string
}

export interface UserActivity {
  event: string
  price: number
  addresserAddress: string
  recipientAddress: string
  eventDate: string
}

export enum PublicUserRole {
  CREATOR = 'creator',
  GAME_DEV = 'game-developer'
}

export enum UserRole {
  USER = 'user',
  ADMIN = 'admin',
  SUPER_ADMIN = 'super-admin',
  CREATOR = 'creator',
  OWNER = 'owner',
  GAME_DEV = 'game-developer',
  TEAM_MEMBER = 'team-member'
}

export interface User {
  id: string
  userId: string

  role: string | string[]
  addresses: Wallet[]
  socialMedia: SocialMedia[]
  personalDetails?: PersonalDetails
  elympicsUserId?: string

  createdAt: string
  updatedAt: string

  activities: UserActivity[]

  engagementPoints?: number

  rulesCheckbox?: {
    checked: boolean
    updatedAt: string
  }

  externalAccounts?: {
    name: string
    data: { id?: string; username?: string; email?: string }
  }[]
}

export enum UserState {
  UNAUTHORIZED = 'unauthorized',
  AUTHORIZED = 'authorized',
  VERIFIED = 'verified'
}

export enum SortUserKey {
  USER_ROLE = 'role',
  CREATED_AT = 'createdAt',
  VISITED_AT = 'visitedAt'
}

export enum UserApiTag {
  USER = 'User'
}
